<template>
    <div class="delivery-routes-day">
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between mb-3">
                    <div>
                        <a href="/espace-employes/tournees-livraison" class="btn btn-outline-dark btn-sm">
                            <i class="small fas fa-arrow-circle-left"></i>
                            Retour aux tournées de la semaine
                        </a>
                    </div>
                    <div>
                        <button v-if="sending" class="btn btn-outline-primary btn-sm disabled">
                            <i class="fad fa-spin fa-spinner mr-2"></i> Sauvegarde en cours
                        </button>
                        <button v-else-if="loading" class="btn btn-outline-primary btn-sm disabled">
                            <i class="fad fa-spin fa-spinner mr-2"></i> Chargement en cours
                        </button>
                        <button v-else @click="updateRouteDay()" class="btn btn-outline-success btn-sm">
                            <i class="fad fa-save mr-2"></i> Sauvegarder
                        </button>
                    </div>
                </div>
                <div>
                    <transition name="loading-screen">
                        <loading-screen v-if="loading"/>
                        <loading-screen v-if="sending"/>
                    </transition>
                    <errors-zone :errors="errors"/>
                    <errors-zone :errors="errorsSending"/>
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <div class="card mb-2">
                                <div class="card-header">
                                    Clients du {{ day }} :

                                    <button v-if="sending || loading" class="btn btn-outline-primary btn-sm disabled">
                                        <i class="fad fa-spin fa-spinner mr-2"></i> Sauvegarde en cours
                                    </button>
                                    <button v-else-if="loading" class="btn btn-outline-primary btn-sm disabled">
                                        <i class="fad fa-spin fa-spinner mr-2"></i> Chargement en cours
                                    </button>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <draggable :forceFallback="true" class="list-group" :list="customers"
                                                   group="customers" :sort="false" @end="sortCustomers">
                                            <div
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="(customer, index) in customers"
                                                :key="customer.name"
                                                v-if="customer.delivery_days_numeric.includes(numericDay)"
                                            >
                                                <div>
                                                    {{ customer.name }}
                                                    <span class="text-muted font-italic small ml-3">
                                                        {{ customer.type_label }}
                                                    </span>
                                                    <span class="text-danger small ml-3 px-1"
                                                          v-if="!customer.delivery_days_numeric.includes(numericDay)">
                                                        Non autorisé le {{ day }}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span class="ml-3 dropdown show">
                                                        <a class="text-muted dropdown-toggle" href="javascript:void(0)"
                                                           role="button" data-toggle="dropdown">
                                                            Tournée
                                                        </a>

                                                        <div class="dropdown-menu">
                                                            <a class="dropdown-item" href="javascript:void(0)"
                                                               @click="addToDeliveryRoute(deliveryRoute, customer)"
                                                               v-for="deliveryRoute in deliveryRoutes">
                                                                {{ deliveryRoute.name }}
                                                            </a>
                                                        </div>
                                                    </span>
                                                    <a class="ml-3 text-muted"
                                                       :href="`/espace-employes/clients/${customer.id}`"
                                                       target="_blank">
                                                        <i class="fas fa-external-link"></i> Voir
                                                    </a>
                                                </div>
                                            </div>
                                        </draggable>
                                    </div>
                                    <div class="mt-3">
                                        <draggable :forceFallback="true" class="list-group" :list="customers"
                                                   group="customers" :sort="false" @end="sortCustomers">
                                            <div
                                                class="list-group-item d-flex justify-content-between"
                                                v-for="(customer, index) in customers"
                                                :key="customer.name"
                                                v-if="!customer.delivery_days_numeric.includes(numericDay)"
                                            >
                                                <div>
                                                    {{ customer.name }}
                                                    <span class="text-muted font-italic small ml-3">
                                                        {{ customer.type_label }}
                                                    </span>
                                                    <span class="text-danger small ml-3 px-1"
                                                          v-if="!customer.delivery_days_numeric.includes(numericDay)">
                                                        Non autorisé le {{ day }}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span class="ml-3 dropdown show">
                                                        <a class="text-muted dropdown-toggle" href="javascript:void(0)"
                                                           role="button" data-toggle="dropdown">
                                                            Tournée
                                                        </a>

                                                        <div class="dropdown-menu">
                                                            <a class="dropdown-item" href="javascript:void(0)"
                                                               @click="addToDeliveryRoute(deliveryRoute, customer)"
                                                               v-for="deliveryRoute in deliveryRoutes">
                                                                {{ deliveryRoute.name }}
                                                            </a>
                                                        </div>
                                                    </span>
                                                    <a class="ml-3 text-muted"
                                                       :href="`/espace-employes/clients/${customer.id}`"
                                                       target="_blank">
                                                        <i class="fas fa-external-link"></i> Voir
                                                    </a>
                                                </div>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6">
                            <div class="card mb-2" v-for="deliveryRoute in deliveryRoutes">
                                <div class="card-header">
                                    Tournée : {{ deliveryRoute.name }}
                                    <span class="text-muted font-italic small">{{ deliveryRoute.day_label }}</span>
                                </div>
                                <div class="card-body">
                                    <draggable :forceFallback="true" class="list-group" :list="deliveryRoute.customers"
                                               group="customers" @end="sortCustomers">
                                        <div
                                            class="list-group-item d-flex justify-content-between"
                                            v-for="(customer, index) in deliveryRoute.customers"
                                            :key="customer.name"
                                        >
                                            <div>
                                                {{ customer.name }}
                                                <span class="text-muted font-italic small ml-3">
                                                    {{ customer.type_label }}
                                                </span>
                                                <span class="text-danger small ml-3 px-1"
                                                      v-if="!customer.delivery_days_numeric.includes(numericDay)">
                                                    Non autorisé le {{ day }}
                                                </span>
                                                <span class="text-muted ml-3">-</span>
                                                <span class="text-muted ml-3">Étape n°{{ index + 1 }}</span>
                                            </div>
                                            <div>
                                                <span class="ml-3 dropdown show">
                                                    <a class="text-muted dropdown-toggle" href="javascript:void(0)"
                                                       role="button" data-toggle="dropdown">
                                                        Tournée
                                                    </a>

                                                    <div class="dropdown-menu">
                                                        <a class="dropdown-item" href="javascript:void(0)"
                                                           @click="changeDeliveryRoute(deliveryRoute, _deliveryRoute, customer)"
                                                           v-for="_deliveryRoute in deliveryRoutes"
                                                           v-if="deliveryRoute.id !== _deliveryRoute.id">
                                                            {{ _deliveryRoute.name }}
                                                        </a>
                                                        <a class="dropdown-item text-muted" href="javascript:void(0)"
                                                           @click="removeFromDeliveryRoute(deliveryRoute, customer)">
                                                            <i><i class="fa fa-trash"></i> Retirer des tournées</i>
                                                        </a>
                                                    </div>
                                                </span>
                                                <a class="ml-3 text-muted"
                                                   :href="`/espace-employes/clients/${customer.id}`" target="_blank">
                                                    <i class="fas fa-external-link"></i> Voir
                                                </a>
                                            </div>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import ErrorsZone from "./ErrorsZone";
import LoadingScreen from "./LoadingScreen";
import {useGetLoader} from "./compositions/axios/loadingRequest"
import {usePostRequest} from "./compositions/axios/postRequest";

export default {
    name: 'DeliveryRoutesDay',

    components: {
        'errors-zone': ErrorsZone,
        'loading-screen': LoadingScreen,
        draggable,
    },

    props: {
        day: {
            type: String,
            required: true,
        },
        numericDay: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            deliveryRoutes: [],
            customers: [],
        };
    },

    setup(props) {
        const {
            loading: loading,
            loaded: loaded,
            errors: errors,
            load: load,
        } = useGetLoader();

        const {
            loading: sending,
            loaded: sent,
            errors: errorsSending,
            post: doPost,
        } = usePostRequest();

        return {
            loading,
            loaded,
            errors,
            load,

            sending,
            sent,
            errorsSending,
            doPost,
        };
    },

    mounted() {
        this.loadState();
    },

    methods: {
        changeDeliveryRoute: function (oldDeliveryRoute, newDeliveryRoute, customer) {
            this.removeFromDeliveryRoute(oldDeliveryRoute, customer);
            this.addToDeliveryRoute(newDeliveryRoute, customer);
        },

        removeFromDeliveryRoute: function (deliveryRoute, customer) {
            for (let index in deliveryRoute.customers) {
                let _customer = deliveryRoute.customers[index];
                if (_customer.id === customer.id) {
                    deliveryRoute.customers.splice(index, 1);
                    this.customers.push(customer);
                }
            }
            this.sortCustomers();
        },

        addToDeliveryRoute: function (deliveryRoute, customer) {
            for (let index in this.customers) {
                let _customer = this.customers[index];
                if (_customer.id === customer.id) {
                    this.customers.splice(index, 1);
                    deliveryRoute.customers.push(customer);
                }
            }
            this.sortCustomers();
        },

        sortCustomers: function () {
            this.customers = _.orderBy(_.values(this.customers), ['name']);
        },

        async loadState() {
            this.loading = true;
            const response = await this.load('/espace-employes/tournees-livraison/jour/' + this.day + '/json');
            if (response && response.deliveryRoutes) {
                this.deliveryRoutes = response.deliveryRoutes;
                this.customers = response.customers;
                this.sortCustomers();
            }
            this.loading = false;
        },

        async updateRouteDay() {
            this.$emit('submitted');
            this.sending = true;

            await this.doPost('/espace-employes/tournees-livraison/jour/' + this.day, {
                deliveryRoutes: this.deliveryRoutes,
            });

            this.$emit('errors', this.errorsSending);
            if (!this.errorsSending) {
                if (!this.$root.echoConnectedWihoutErrors) {
                    window.location.reload();
                }
            }
            this.sending = false;
            await this.loadState();
        },
    }
}
</script>
